import { render, staticRenderFns } from "./BDDetails.vue?vue&type=template&id=7412d2de&scoped=true&"
import script from "./BDDetails.vue?vue&type=script&lang=js&"
export * from "./BDDetails.vue?vue&type=script&lang=js&"
import style0 from "./BDDetails.vue?vue&type=style&index=0&id=7412d2de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412d2de",
  null
  
)

export default component.exports